export default __webpack_public_path__ + "static/media/template_1.49340875.svg";